import React, { useState, useEffect } from 'react';
import Portfolio from './components/Portfolio';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    // Check system preference on initial load
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  return (
    <Portfolio darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
  );
}

export default App;
